import { EMPLOYMENT_INDUSTRY } from 'cpool-constants';
import { z } from 'zod';

import { schemaEuropaceAnschrift } from '../../Anschrift.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#firma

	{
		"anschrift": Anschrift,
		"branche": "BAUGEWERBE" | "DIENSTLEISTUNGEN" | "ENERGIE_WASSERVERSORGUNG_BERGBAU" | "ERZIEHUNG_UNTERRICHT" | "GEBIETSKOERPERSCHAFTEN" | "GEMEINNUETZIGE_ORGANISATION" | "GESUNDHEIT_SOZIALWESEN" | "HANDEL" | "HOTEL_GASTRONOMIE" | "INFORMATION_KOMMUNIKATION" | "KREDITINSTITUTE_VERSICHERUNGEN" | "KULTUR_SPORT_UNTERHALTUNG" | "LANDWIRTSCHAFT_FORSTWIRTSCHAFT_FISCHEREI" | "OEFFENTLICHER_DIENST" | "PRIVATE_HAUSHALTE" | "VERARBEITENDES_GEWERBE" | "VERKEHR_LOGISTIK",
		"name": String
	}

*/
export const schemaEuropaceFirma = z.object({
    anschrift: z.optional(schemaEuropaceAnschrift),
    branche: z.optional(z.nativeEnum(EMPLOYMENT_INDUSTRY)),
    name: z.optional(z.string()),
});

export type SchemaEuropaceFirma = z.infer<typeof schemaEuropaceFirma>;
